import axios, { AxiosError } from "axios";
import type { ApiError } from "../types";

const BASE_URL = import.meta.env.VITE_API_BASE_URL || "";

export const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30_000, // 30 seconds
});

// Request interceptor: add auth token if present
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor: normalize errors
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError<ApiError>) => {
    if (error.response) {
      const detail = error.response.data?.detail;
      if (typeof detail === "string") {
        error.message = detail;
      } else if (Array.isArray(detail) && detail.length > 0) {
        error.message = detail.map((d) => d.msg).join("; ");
      }
    } else if (error.request) {
      error.message = "Impossible de contacter le serveur. Vérifiez votre connexion.";
    }
    return Promise.reject(error);
  }
);

export default apiClient;
